export default __webpack_public_path__ + "static/easylife365_collaboration_logo-82b12735ba88b087f5fb7b355364604b.svg";